module.exports = __webpack_public_path__ + "img/rocket.16ad4d8d.svg";